import { createSelector } from 'reselect';
import { DEFAULT_SELECT  } from '@containers/ticketMgmtPortal/forms/ticketFormConfigs';

export const ticketCategoriesSelector = (state) => state.ticketMgmt.categories.entities;
export const ticketCategoriesLoadedSelector = (state) => state.ticketMgmt.categories.loaded;
export const activeCategorySelector = (state) => state.ticketMgmt?.categories.activeCategory;
export const searchTktCategoriesAndTypesSelector = (state) => state.ticketMgmt?.categories.searchTktCategoriesAndTypeResults;
export const workflowsByCategoryLoadedSelector = (state) => state.ticketMgmt.ticketTypes.loaded;
export const workflowsByCategorySelector = (state) => state.ticketMgmt.ticketTypes.entities;
export const ticketTypeSelectOptionsLoadedSelector = (state) => state.ticketMgmt.ticketTypes.options.optionsLoaded;
export const ticketFormOptionsSelector = (state) => state.ticketMgmt.ticketTypes.options;
export const ticketTypeFormOpenState = (state) => state.ticketMgmt.ticketTypes.isFormOpen;
export const ticketTypeDetailsDrawerOpenState = (state) =>  state.ticketMgmt.ticketTypes.isDrawerOpen; 
export const ticketTypeSuccessMessageSelector = (state) => state.ticketMgmt.ticketTypes.ticketTypeFormMessage;
export const ticketTypeFormDirtyStateSelector = (state) => state.ticketMgmt.ticketTypes.isFormDirty;
export const selectedTicketDetailsSelector = (state) =>  state.ticketMgmt.ticketTypes.ticketDetails;
export const ticketCategorySuccessMsgSelector = (state) => state.ticketMgmt.ticketTypes.categorySuccessMsg;
export const tktCategoryNavigationStateSelector = (state) => state.ticketMgmt.ticketTypes.showTktCategoryNavigation;

export const workgroupsOptionsSelector = createSelector(
    ticketFormOptionsSelector,
    ({ workgroups }) =>
        workgroups
            .reduce((acc, workgroup) => ([...acc, { value: workgroup.queueId, label: workgroup.label }]), [{ label: DEFAULT_SELECT, value: DEFAULT_SELECT }])
            .sort((a, b) => a.label.localeCompare(b.label))
);

export const sortedWorkflowsByCategorySelector = createSelector(
    workflowsByCategorySelector,
    ( workflows ) => {
        if (workflows && workflows.length > 0) {
            return workflows.slice().sort((a, b) => a.status.localeCompare(b.status) || a.type.localeCompare(b.type));
        }
        return [];
    }
);

